import * as React from 'react';

import { EXTRA_SMALL_ICON_BASE_SRC } from '../../../../Shared/index';

const accountIcon = `${EXTRA_SMALL_ICON_BASE_SRC}/account.svg`

const ProjectorHeader = ({ studentCount, submissions, label = 'Students type response' }: { studentCount?: number, submissions?: any, label?: string }) => {
  const submissionCount = submissions ? Object.keys(submissions).length : 0
  const studentCountText = studentCount ? `${submissionCount} of ${studentCount} have responded` : ''

  const hasCount = studentCount > 0

  return (
    <div className="projector-footer">
      <div className={`projector-footer-content${hasCount ? '' : ' no-count'}`}>
        <div className="projector-footer-label">
          <img alt="" src={accountIcon} />
          <strong>{label}</strong>
        </div>
        {hasCount && <div className="projector-footer-divider" />}
        {hasCount && <p className="projector-footer-count">{studentCountText}</p>}
      </div>
    </div>
  )
}

export default ProjectorHeader
